/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { Component } from 'react';
import { Modal, Form } from 'semantic-ui-react';
import { observer, inject } from 'mobx-react';
import FileSaver from 'file-saver';
import WithRouter from '../Extensions/WithRouter';
import { convertPropertiesToCamelCase } from '../../utils/shared';
import api from '../../api';
import closeBtn from '../../images/common/close-btn.svg';
import Loader from '../Loader/Loader';
import {
  SPDX_EXTENSION_JSON,
  SPDX_EXTENSION_XML,
} from '../../constants/reports';
import './VexGenerator.css';

class VexGenerator extends Component {
  constructor(props) {
    super(props);
    this.modalBody = null;
    this.state = {
      isOpenMVX: props.isOpenMVX,
      isDownloadLoading: false,
      isLoading: false,
      isOpenWarnModal: false,
      componentType: 'application',
      componentName: '',
      modalValue: '',
      exportFormat: SPDX_EXTENSION_JSON,
      componentNameError: false,
    };
    this.handleExportFormat = this.handleExportFormat.bind(this);
    this.handleComponentType = this.handleComponentType.bind(this);
    this.handleComponentNameChange = this.handleComponentNameChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.validateForm = this.validateForm.bind(this);
    this.createVexFileDownload = this.createVexFileDownload.bind(this);
    this.runWithModalValue = this.runWithModalValue.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.closeWarnModal = this.closeWarnModal.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { isOpenMVX } = this.props;
    if (prevProps.isOpenMVX !== isOpenMVX) {
      this.setState({
        isOpenMVX,
        modalValue: '',
        isOpenWarnModal: false,
        componentType: 'application',
        componentName: '',
        componentNameError: false,
        exportFormat: SPDX_EXTENSION_JSON,
      }, () => {
        if (isOpenMVX) {
          this.getPacakageInfoWithVex();
        }
      });
    }
  }

  handleExportFormat(e) {
    this.setState({
      exportFormat: e.target.value,
    });
  }

  handleComponentType(e) {
    this.setState({
      componentType: e.target.value,
    });
  }

  handleComponentNameChange(e) {
    this.setState({
      componentName: e.target.value,
      componentNameError: false,
    });
  }

  onSubmit() {
    const { translate } = this.props;

    if (!this.validateForm()) {
      return;
    }

    this.modalHeader = translate('modal.title.notice');
    this.modalBody = translate('modal.message.create_document');
    this.setState({
      isOpenWarnModal: true,
      modalValue: 'create',
    });
  }

  validateForm = () => {
    const {
      componentName,
    } = this.state;

    const validation = {
      componentType: true,
      componentName: true,
    };

    if (componentName.trim().length === 0) {
      this.setState({
        componentNameError: true,
      });
      validation.componentName = false;
      this.componentName.focus();
      this.componentName.scrollIntoView();
      return false;
    }

    return validation.componentType && validation.componentName;
  };

  getPacakageInfoWithVex = () => {
    const { reportId } = this.props;
    this.setState({
      isLoading: true,
    }, () => {
      api
        .getPacakageInfoWithVex(reportId)
        .then((response) => {
          const data = convertPropertiesToCamelCase(response.response);
          this.setState({
            isLoading: false,
            componentName: data.componentName,
            componentType: data.componentType,
          });

        })
        .catch((err) => {
          console.log(err);
          this.setState({
            isLoading: false,
          });
        });
    });
  };

  createVexFileDownload = () => {
    const { reportId, closeModal, state } = this.props;
    const {
      exportFormat,
      componentType,
      componentName,
      isDownloadLoading
    } = this.state;

    const obj = {
      export_format: exportFormat,
      component_type: componentType,
      component_name: componentName,
    };

    if (state.user.currentPrecisionLevel) {
      obj.precision_level = state.user.currentPrecisionLevel;
    }

    const fileName = `sbom.vex.clarity-${componentName}.${exportFormat}`;

    if (isDownloadLoading) {
      api
        .createVexFileDownload(reportId, obj)
        .then((res) => {
          const blob = new Blob([res], { type: 'application/octet-stream' });
          FileSaver.saveAs(blob, fileName);

          this.setState({
            isDownloadLoading: false,
          });
          closeModal();
        })
        .catch((err) => {
          console.log(err);
          this.setState({
            isDownloadLoading: false,
          });
        });
    }
  };

  runWithModalValue() {
    const { closeModal } = this.props;
    const { modalValue } = this.state;

    if (modalValue.indexOf('create') > -1) {
      this.setState({
        isOpenWarnModal: false,
        isDownloadLoading: true,
      }, () => {
        this.createVexFileDownload();
      });
    } else {
      closeModal();
    }
  }

  closeModal(e) {
    const { translate } = this.props;
    if (e.target.classList[0] === 'right_button') {
      return null;
    }

    this.modalHeader = translate('modal.title.attention');
    this.modalBody = translate('modal.message.create_document_cancel');
    this.setState({
      isOpenWarnModal: true,
      modalValue: 'MVX',
    });
  }

  closeWarnModal() {
    this.setState({
      isOpenWarnModal: false,
    });
  }

  render() {
    const { translate } = this.props;
    const {
      isOpenWarnModal,
      componentType,
      componentName,
      isOpenMVX,
      isLoading,
      isDownloadLoading,
      exportFormat,
      componentNameError,
    } = this.state;

    const getModalContent = () => {
      if (isDownloadLoading) {
        return (
          <div className="setting_popup_wrap">
            <div className="setting_popup vex">
              <div style={{ verticalAlign: 'middle', textAlign: 'center', marginTop: '20%' }}>
                <Loader
                  style={{
                    position: 'relative',
                    width: '80%',
                    height: '80%',
                    marginBottom: '15%',
                  }}
                />
                <span
                  style={{
                    fontWeight: '500',
                    fontSize: '16px',
                    marginTop: '60%',
                    display: 'inline-block',
                  }}
                >
                  {translate('modal.message.prepare_vex_download')}
                </span>
              </div>
            </div>
          </div>
        );
      }

      if (isLoading) {
        return (
          <div className="setting_popup_wrap">
            <div className="setting_popup vex">
              <div style={{ verticalAlign: 'middle', textAlign: 'center', marginTop: '20%' }}>
                <Loader
                  style={{
                    position: 'relative',
                    width: '80%',
                    height: '80%',
                    marginBottom: '15%',
                  }}
                />
                <span
                  style={{
                    fontWeight: '500',
                    fontSize: '16px',
                    marginTop: '60%',
                    display: 'inline-block',
                  }}
                >
                  {translate('modal.message.loading')}
                </span>
              </div>
            </div>
          </div>
        );
      }

      return (
        <div>
          <div className="setting_popup_wrap">
            <div
              className="setting_popup vex"
            >
              <div className="setting_popup_header">
                <h2 className="popup_name">{translate('modal.title.create_vex_bom')}</h2>
                <a
                  className="popup_close_button"
                  onKeyUp={this.closeModal}
                  onClick={this.closeModal}
                >
                  <img src={closeBtn} alt="" />
                </a>
              </div>
              <Form>
                <Form.Field style={{ marginTop: '2em' }}>
                  <label>{translate('modal.title.export_format')}</label>
                  <select value={exportFormat} onChange={this.handleExportFormat}>
                    <option value={SPDX_EXTENSION_JSON}>JSON</option>
                    <option value={SPDX_EXTENSION_XML}>XML</option>
                  </select>
                </Form.Field>
                <Form.Field>
                  <label>
                    {translate('modal.title.component_type')}
                    <em style={{ marginLeft: '0' }} className="asterisk" />
                  </label>
                  <select value={componentType} onChange={this.handleComponentType}>
                    <option value="application">Application</option>
                    <option value="framework">Framework</option>
                    <option value="library">Library</option>
                    <option value="container">Container</option>
                    <option value="operating-system">OperatingSystem</option>
                    <option value="device">Device</option>
                    <option value="firmware">Firmware</option>
                    <option value="file">File</option>
                  </select>
                </Form.Field>
                <Form.Field error={componentNameError}>
                  <label
                    ref={(ref) => {
                      this.componentName = ref;
                    }}
                  >
                    {translate('modal.title.component_name_cyclonedx')}
                    <em style={{ marginLeft: '0' }} className="asterisk" />
                  </label>
                  <input
                    type="text"
                    placeholder={translate('modal.title.component_name_cyclonedx')}
                    value={componentName}
                    onChange={this.handleComponentNameChange}
                  />
                </Form.Field>
              </Form>
              <div className="setting_popup_button_wrap_flex">
                <a
                  className="button cencel_button"
                  onKeyUp={this.closeModal}
                  onClick={this.closeModal}
                  style={{ cursor: 'pointer' }}
                >
                  {translate('modal.button.cancel')}
                </a>
                <a
                  className="button save_button"
                  onKeyUp={this.closeModal}
                  onClick={this.onSubmit}
                  style={{ cursor: 'pointer' }}
                >
                  {translate('modal.button.ok')}
                </a>
              </div>
            </div>
          </div>
          <Modal open={isOpenWarnModal} onClose={this.closeWarnModal}>
            <div className="modal_popup_wrap confirm_wrap">
              <div className="modal_popup_box confirm_box">
                <div className="modal_popup confirm">
                  <h2 className="title">{this.modalHeader}</h2>
                  <p className="text">{this.modalBody}</p>
                  <div className="button_wrap">
                    <a
                      className="left_button"
                      onKeyUp={this.closeWarnModal}
                      onClick={this.closeWarnModal}
                    >
                      {translate('modal.button.cancel')}
                    </a>
                    <a
                      className="right_button"
                      onKeyUp={this.runWithModalValue}
                      onClick={this.runWithModalValue}
                    >
                      {translate('modal.button.ok')}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </Modal>
        </div>
      );
    };
    return (
      <Modal open={isOpenMVX} onClose={this.closeModal} className="create_vex">
        {getModalContent()}
      </Modal>
    );
  }
}

export default WithRouter(inject('state')(observer(VexGenerator)));
